// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-footnote_root__np6p1"};